import { Route } from "react-router-dom";
import UiConfiguration from "../pages/UIConfiguration/UiConfiguration";

/**
 * 🎨 Rutas del módulo de Configuración UI
 *
 * Estas rutas permiten gestionar la visibilidad y apariencia
 * de los elementos de la interfaz del sistema (UI).
 */
const uiConfigurationRoutes = (
  <>
    <Route path="/ui/configuration" element={<UiConfiguration />} />
  </>
);

export default uiConfigurationRoutes;
